const PANELS = {
    Organizations(vm) {
        const ctx = vm
        return {
            component: 'DashboardOrganizationsDrawerPanel',
            props: {
                search: ctx.drawerSearch,
                sortBy: ctx.orgSortBy,
                sortDirection: ctx.orgSortDirection,
                sortOptions: ctx.orgSortOptions,
                sortDirectionOptions: ctx.sortDirectionOptions,
            },
            on: {
                create: ctx.handleCreate,
                'apply-search': ctx.applySearch,
                'apply-sort': ctx.applyOrgSort,
                'update:search': (value) => { ctx.drawerSearch = value },
                'update:sortBy': (value) => { ctx.orgSortBy = value },
                'update:sortDirection': (value) => { ctx.orgSortDirection = value },
            },
        }
    },
}

export const dashboardContextDrawerRoutes = Object.freeze(Object.keys(PANELS))

export function getDashboardContextDrawerPanel(vm) {
    const factory = PANELS[vm.routeName]
    if (!factory) return { component: null, props: {}, on: {} }
    return factory(vm)
}
